<ng-container *ngFor="let product of products">
	<div class="data" *ngIf="product.rooms">
		<div class="product">
			<div class="name">
				<a routerLink="/product/{{ product.id }}/" target="_blank">
					{{ product.name }}
				</a>
			</div>
			<div class="used">Wykorzystano: {{ product.occupancy }}</div>
			<div class="btn btn-link" (click)="availabilitySet(product)"><i class="fas fa-edit"></i> Dostępność</div>
			<div class="btn btn-link" (click)="capaciteisWihtOutRooms(product)">
				<i class="fas fa-edit"></i> Nie zakwaterowane
			</div>
		</div>
		<div class="rooms">
			<app-accommodations-products-rooms
				*ngFor="let room of product.rooms"
				[room]="room"
				[occupancy]="room.occupancy"
				[name]="room.name"
				[product]="product"
			></app-accommodations-products-rooms>
		</div>
	</div>
</ng-container>
